import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface GlobalRankByMaterialProps {
    dateRange: { startDate: string; endDate: string };
    productName: string;
}

export const GlobalRankByMaterial = ({ dateRange, productName }: GlobalRankByMaterialProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.PRODUCTS_LOCATION_GLOBAL_RANK_OF_MATERIAL,
        params: { ...dateRange, productName },
    });

    return (
        <BaseReport
            title={`Global Rank for ${productName} Cut Volume`}
            description={`This table shows you the number of cuts of ${productName} film for each location, along with their world rank, for the entire date range above.`}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', `${productName} Cuts`, 'World Rank'],
                data: data.map((item) => [item.locationName, item.resellerName, item.materialCuts, item.worldRank]),
                summaries: [countUnique, countUnique, sum, count],
                sort: [basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
